import { Deserializer } from 'jsonapi-serializer'

/**
 * JSON API Deserializer
 */

export default new Deserializer({ keyForAttribute: 'snake_case' })
